import React, { useEffect, useState } from "react";
import "./css/greeting.css";
import Loading from "./Loading";

// --- 画像読み込み（省略せず全て）
import reno1 from "../assets/img/greeting/3-reno.webp";
import reno2 from "../assets/img/greeting/4-reno.webp";
import reno3 from "../assets/img/greeting/5-reno.webp";
import reno4 from "../assets/img/greeting/6-reno.webp";
import reno5 from "../assets/img/greeting/7-reno.webp";
import reno6 from "../assets/img/greeting/8-reno.webp";
import reno7 from "../assets/img/greeting/9-reno.webp";
import reno8 from "../assets/img/greeting/10-reno.webp";
import reno9 from "../assets/img/greeting/11-reno.webp";
import reno10 from "../assets/img/greeting/12-reno.webp";
import reno11 from "../assets/img/greeting/13-reno.webp";
import reno12 from "../assets/img/greeting/14-reno.webp";

// --- teru images
import teru1 from "../assets/img/greeting/3-teru.webp";
import teru2 from "../assets/img/greeting/4-teru.webp";
import teru3 from "../assets/img/greeting/5-teru.webp";
import teru4 from "../assets/img/greeting/6-teru.webp";
import teru5 from "../assets/img/greeting/7-teru.webp";
import teru6 from "../assets/img/greeting/8-teru.webp";
import teru7 from "../assets/img/greeting/9-teru.webp";
import teru8 from "../assets/img/greeting/10-teru.webp";
import teru9 from "../assets/img/greeting/11-teru.webp";
import teru10 from "../assets/img/greeting/12-teru.webp";
import teru11 from "../assets/img/greeting/13-teru.webp";
import teru12 from "../assets/img/greeting/14-teru.webp";

// --- pair images
import pair1 from "../assets/img/greeting/15.webp";
import pair2 from "../assets/img/greeting/16.webp";
import pair3 from "../assets/img/greeting/17.webp";
import pair4 from "../assets/img/greeting/18.webp";
import pair5 from "../assets/img/greeting/19.webp";
import pair6 from "../assets/img/greeting/20.webp";
import pair7 from "../assets/img/greeting/21.webp";
import pair8 from "../assets/img/greeting/22.webp";
import pair9 from "../assets/img/greeting/23.webp";
import pair10 from "../assets/img/greeting/24.webp";
import pair11 from "../assets/img/greeting/25.webp";
import pair12 from "../assets/img/greeting/26.webp";
import pair13 from "../assets/img/greeting/27.webp";
import pair14 from "../assets/img/greeting/28.webp";
import pair15 from "../assets/img/greeting/29.webp";
import pair16 from "../assets/img/greeting/30.webp";
import pair17 from "../assets/img/greeting/31.webp";
import pair18 from "../assets/img/greeting/32.webp";
import pair19 from "../assets/img/greeting/33.webp";
import pair20 from "../assets/img/greeting/34.webp";
import pair21 from "../assets/img/greeting/35.webp";
const renos = [
  reno1,
  reno2,
  reno3,
  reno4,
  reno5,
  reno6,
  reno7,
  reno8,
  reno9,
  reno10,
  reno11,
  reno12,
];
const terus = [
  teru1,
  teru2,
  teru3,
  teru4,
  teru5,
  teru6,
  teru7,
  teru8,
  teru9,
  teru10,
  teru11,
  teru12,
];
const pairs = [
  pair1,
  pair2,
  pair3,
  pair4,
  pair5,
  pair6,
  pair7,
  pair8,
  pair9,
  pair10,
  pair11,
  pair12,
  pair13,
  pair14,
  pair15,
  pair16,
  pair17,
  pair18,
  pair19,
  pair20,
  pair21,
];

const Greeting = ({ onFinish }) => {
  const [frameIndex, setFrameIndex] = useState(0);
  const [phase, setPhase] = useState("walk"); // 'walk' → 'pair'
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [isFinished, setIsFinished] = useState(false);
  const [isReady, setIsReady] = useState(false);
  // const [hasSeen, setHasSeen] = useState(false);
  const [hasSeen] = useState(false);

  // 一度見られたか
  //   useEffect(() => {
  //   const seen = localStorage.getItem("hasSeenGreeting");
  //   if (seen === "true") {
  //     setHasSeen(true);
  //   }
  // }, []);

  // 画像のプリロード
  useEffect(() => {
    // 一旦 next tick で isReady だけ false の状態で描画を開始
    const timer = setTimeout(() => {
      const allImages = [...renos, ...terus, ...pairs];
      preloadImages(allImages).then(() => {
        setIsReady(true);
      });
    }, 0); // 次のイベントループに送ることで、先にLoadingが描画される
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    // アニメーション開始時にスクロール無効化
    document.body.style.overflow = "hidden";

    // アニメーション終了後にスクロール許可 & ページトップへ
    if (isFinished) {
      document.body.style.overflow = "auto";
    }

    // クリーンアップ（万が一 unmount 時も戻す）
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isFinished]);

  useEffect(() => {
    if (!isReady || isFinished) return;
    let timeout;

    if (phase === "walk" && frameIndex < renos.length - 1) {
      const delay = frameIndex === 0 ? 500 : 150; // 最初だけ1秒待機
      timeout = setTimeout(() => {
        setFrameIndex((prev) => prev + 1);
      }, delay);
    }

    if (phase === "walk" && frameIndex === renos.length - 1) {
      timeout = setTimeout(() => {
        setPhase("pair");
        setFrameIndex(0);
      }, 140);
    }

    if (phase === "pair" && frameIndex < pairs.length - 1) {
      timeout = setTimeout(() => {
        setFrameIndex((prev) => prev + 1);
      }, 140);
    }

    if (phase === "pair" && frameIndex === pairs.length - 1) {
      timeout = setTimeout(() => {
        setIsFadingOut(true);
        setTimeout(() => {
          // localStorage.setItem("hasSeenGreeting", "true"); // ← 追加
          setIsFinished(true);
        }, 1000);
        onFinish();
      }, 1000);
    }

    return () => clearTimeout(timeout);
  }, [frameIndex, phase, isReady, isFinished]);

  const preloadImages = (srcArray) => {
    return Promise.all(
      srcArray.map((src) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = src;
          img.onload = resolve;
          img.onerror = resolve;
        });
      })
    );
  };

  if (hasSeen || isFinished) {
    document.body.style.overflow = "auto"; // ここで解除
    return null;
  }

  if (!isReady) return <Loading />;

  return (
    <div className={`walk-container ${isFadingOut ? "fade-out" : ""}`}>
      {phase === "walk" && (
        <>
          <img
            src={renos[frameIndex]}
            alt="れの歩き"
            className={`reno-common reno${frameIndex + 1}`}
          />
          <img
            src={terus[frameIndex]}
            alt="てる歩き"
            className={`teru-common teru${frameIndex + 1}`}
          />
        </>
      )}
      {phase === "pair" && (
        <>
          <img
            src={pairs[frameIndex]}
            alt={`ペア画像${frameIndex + 1}`}
            className={`pair-common pair${frameIndex + 1} ${
              frameIndex === pairs.length - 1 && isFadingOut ? "fade-out" : ""
            }`}
          />
        </>
      )}
    </div>
  );
};

export default Greeting;
